import localStorageHelpers from "shared/util/localStorage";
import Context from "shared/util/Context";

const LOCAL_STORAGE_DEVICE_ID_KEY = "device_id";

const createDeviceId = () => `${(Context.get("userid") || Context.get("guestid")) + new Date().getTime()}`;

export const getOrCreateDeviceId = () => {
	const deviceId = localStorageHelpers.getItem(LOCAL_STORAGE_DEVICE_ID_KEY) || createDeviceId();
	localStorageHelpers.setItem(LOCAL_STORAGE_DEVICE_ID_KEY, deviceId);
	return deviceId;
};

export const setDeviceId = (deviceId) => {
	localStorageHelpers.setItem(LOCAL_STORAGE_DEVICE_ID_KEY, deviceId);
	return deviceId;
};



// WEBPACK FOOTER //
// ./src/shared/util/deviceId.js